




























































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { TranslateResult } from 'vue-i18n';
import { getProductStateColor } from '@/core/typings/enums/ProductState';
import { getProductTypeTranslations } from '@/core/utils/products';
import { saveAs } from '@/web/utils/save-file';
import NavItem from '@/web/components/navigation/NavItem.vue';
import { notify } from '@/web/utils/notify';
import AddCustomerToProductModal from '@/web/components/products/AddCustomerToProductModal.vue';
import SelectAIToneModal from '@/web/components/products/SelectAIToneModal.vue';
import ReportComponent from '@/web/components/reports/ReportComponent.vue';
import { errorToMessage } from '@/core/utils/errors';
import TopNav from '@/web/components/navigation/TopNav.vue';
import PasswordProtectedSection from '@/web/components/navigation/PasswordProtectedSection.vue';
import Status from '@/web/components/customers/Status.vue';
import { formatDate } from '@/web/utils/format';
import PaymentPlanInvoicesModal from '@/web/components/payment-plans/PaymentPlanInvoicesModal.vue';
import GiftsPurchasesTable from '@/web/components/gift/GiftsPurchasesTable.vue';
import HMDialog from '@/web/components/common/HMDialog.vue';
import HMSendEmailModal from '@/web/components/common/HMSendEmailModal.vue';
import HMShareLinkModal from '@/web/components/common/HMShareLinkModal.vue';
import CustomerNotesModal from '@/web/components/customers/CustomerNotesModal.vue';
import { getStudentViewURL } from '@/web/router/custom-domain-utils';
import TeacherPermissionsMixin from '@/web/mixins/TeacherPermissionsMixin';
import { renderHtmlFromEditorJS } from '@/core/utils/utils';
import { HMAlertInfo } from '@/web/components/common';
import CustomerProductReviewModal from '@/web/components/products/CustomerProductReviewModal.vue';
import VClamp from 'vue-clamp';
import MoveCustomersToProduct from '@/web/components/customers/MoveCustomersToProduct.vue';

interface LocalState {
  productTab: string;
  productTabs: { name: string; key?: string }[];
  eventRegistrationInProgress: boolean;
  search: string;
  eventSearch: string;
  privateSpaceSearch: string;
  date: DatePicker;
  eventDate: DatePicker;
  privateSpaceDate: DatePicker;
  purhasesTableFields: PaginatedTableField[];
  eventsTableFields: PaginatedTableField[];
  customersTableFields: PaginatedTableField[];
  waitlistTableFields: PaginatedTableField[];
  privateSpaceTableFields: PaginatedTableField[];
  reports: MetabaseReportReponse[];
  numCustomers: number | null;
  selectedTab: string;
  // reviews
  reviewsSearch: string;
  reviewsDate: DatePicker;
  reviewsTableFields: PaginatedTableField[];
}

export default Vue.extend({
  name: 'ProductDetail',
  mixins: [TeacherPermissionsMixin],
  components: {
    NavItem,
    ReportComponent,
    TopNav,
    PasswordProtectedSection,
    Status,
    GiftsPurchasesTable,
    HMAlertInfo,
    VClamp,
  },
  data(): LocalState {
    return {
      productTab: 'overview',
      productTabs: [
        {
          name: this.$t('PRODUCTS.LABELS.OVERVIEW') as string,
          key: 'overview',
        },
        {
          name: this.$t('PRODUCTS.LABELS.REVIEWS') as string,
          key: 'reviews',
        },
      ],
      eventRegistrationInProgress: false,
      search: '',
      eventSearch: '',
      privateSpaceSearch: '',
      reviewsSearch: '',
      date: {
        startDate: null,
        endDate: null,
      },
      eventDate: {
        startDate: null,
        endDate: null,
      },
      privateSpaceDate: {
        startDate: null,
        endDate: null,
      },
      reviewsDate: {
        startDate: null,
        endDate: null,
      },
      reports: [],
      waitlistTableFields: [
        {
          key: 'email',
          title: this.$t('PRODUCTS.TABLE.EMAIL') as string,
        },
        {
          key: 'ip_address',
          title: this.$t('PRODUCTS.TABLE.IP_ADDRESS') as string,
        },
        {
          name: 'created',
          title: this.$t('PRODUCTS.TABLE.SUBSCRIBED') as string,
        },
      ],
      purhasesTableFields: [
        {
          name: 'first_name',
          // key: 'student.first_name',
          title: this.$t('PRODUCTS.TABLE.FIRST_NAME') as string,
          cssClass: 'h5 m-0',
        },
        {
          key: 'student.last_name',
          title: this.$t('PRODUCTS.TABLE.LAST_NAME') as string,
          cssClass: 'h5 m-0',
        },
        {
          key: 'student.email',
          title: this.$t('PRODUCTS.TABLE.STUDENT_EMAIL') as string,
        },
        {
          name: 'status',
          title: this.$t('PRODUCTS.TABLE.STATUS') as string,
        },
        {
          name: 'is_payment_plan',
          title: '',
          cssClass: 'h5 m-0',
        },
        {
          name: 'created',
          title: this.$t('PRODUCTS.TABLE.PURCHASED') as string,
        },
        {
          name: 'is_outside_product_schedule',
        },
        {
          name: 'edit',
        },
      ],
      eventsTableFields: [
        {
          name: 'event_name',
          // key: 'student.first_name',
          title: this.$t('EVENTS.LABEL.EVENT_NAME') as string,
          cssClass: 'h5 m-0',
          ordering: 'event_name',
        },
        {
          name: 'event_start_datetime',
          title: this.$t('EVENTS.LABEL.START') as string,
          ordering: 'event_start_datetime',
        },
        {
          name: 'number_of_registrations',
          title: this.$t('EVENTS.LABEL.REGISTRATIONS') as string,
          ordering: 'number_of_registrations',
        },
        {
          name: 'edit',
        },
      ],
      customersTableFields: [
        {
          name: 'first_name',
          // key: 'student.first_name',
          title: this.$t('PRODUCTS.TABLE.FIRST_NAME') as string,
          cssClass: 'h5 m-0',
        },
        {
          key: 'last_name',
          title: this.$t('PRODUCTS.TABLE.LAST_NAME') as string,
          cssClass: 'h5 m-0',
        },
        {
          key: 'email',
          title: this.$t('PRODUCTS.TABLE.STUDENT_EMAIL') as string,
        },
        {
          name: 'status',
          title: this.$t('PRODUCTS.TABLE.STATUS') as string,
        },
        {
          name: 'first_purchase',
          title: this.$t('PRODUCTS.TABLE.PURCHASED') as string,
        },
        {
          name: 'has_notes',
          title: this.$t('PRODUCTS.TABLE.NOTES') as string,
        },
      ],
      privateSpaceTableFields: [
        {
          key: 'product_name',
          cssClass: 'h5 m-0',
          title: this.$t('PRODUCTS.TABLE.PRODUCT') as string,
        },
        {
          key: 'student.email',
          title: this.$t('PRODUCTS.TABLE.STUDENT_EMAIL') as string,
        },
        {
          name: 'created',
          title: this.$t('PRODUCTS.TABLE.CREATED') as string,
        },
      ],
      reviewsTableFields: [
        {
          name: 'review',
          title: this.$t('PRODUCTS.TABLE.REVIEW') as string,
        },
        {
          name: 'rating',
          title: this.$t('PRODUCTS.TABLE.RATING') as string,
          ordering: 'rating',
        },
        {
          name: 'student',
          title: this.$t('PRODUCTS.TABLE.CUSTOMER') as string,
        },
        {
          name: 'status',
          title: this.$t('PRODUCTS.TABLE.STATUS') as string,
        },
        {
          name: 'created',
          title: this.$t('PRODUCTS.TABLE.POSTED') as string,
          ordering: 'created',
        },
        {
          name: 'hidden-toggle',
        },
      ],
      numCustomers: null,
      selectedTab: 'purchased',
      isGeneratingPage: false,
    };
  },
  computed: {
    ...mapGetters({
      teacherProduct: 'product/teacherProduct',
      teacher: 'user/teacher',
      teacherStudioUrl: 'user/teacherStudioUrl',
      teacherMagicCode: 'user/teacherMagicCode',
      domain: 'setting/domain',
    }),
    useCustomDomainUrl: {
      get() {
        return this.$store.getters['setting/useCustomDomainUrl'];
      },
      set(value) {
        this.$store.dispatch('setting/setUseCustomDomainUrl', value);
      },
    },
    canGenerateProductPage() {
      const isPageBuilderEnabled =
        this.teacher?.is_page_builder_enabled || this.hasPageBuilder;
      return (
        isPageBuilderEnabled &&
        this.teacherProduct.product_type !== 'private_space'
      );
    },
    tabs() {
      return [
        {
          name: 'purchased',
          title: this.$t('PRODUCTS.TABLE.PAYMENTS') as string,
        },
        {
          name: 'customers',
          title: this.$t('PRODUCTS.TABLE.CUSTOMERS') as string,
        },
        {
          name: 'gifted',
          title: this.$t('PRODUCTS.TABLE.GIFTED') as string,
        },
        {
          name: 'waitlist',
          title: this.$t('PRODUCTS.TABLE.WAITLIST') as string,
        },
        {
          name: 'events',
          title: this.$t('PRODUCTS.TABLE.EVENTS') as string,
          hidden: !this.showEventsTab,
        },
        {
          name: 'private-space',
          title: this.$t('PRODUCTS.TAB.PRIVATE_SPACE') as string,
          hidden: !this.teacherProduct?.has_private_sessions,
        },
      ];
    },
    showEventsTab() {
      const product = this.teacherProduct;
      if (!product) return false;
      return (
        ['punch_card', 'bundle'].indexOf(product.product_type) === -1 &&
        !product.archived
      );
    },
    isClassCard() {
      return this.teacherProduct?.product_type === 'punch_card';
    },
    visibleTabs() {
      return this.tabs.filter(t => !t.hidden);
    },
    color(): string {
      return getProductStateColor(this.teacherProduct.productState);
    },
    showShareLinkModal() {
      return this.teacherProduct.productState === 'Published';
    },
    studioUrl() {
      if (this.useCustomDomainUrl && this.hasValidCustomDomain) {
        return this.domainName;
      }
      if (process.env.VUE_APP_STUDIO_ON_SUBDOMAINS === 'true') {
        return this.teacherStudioUrl;
      } else {
        const host = window.location.host;
        return `${host}/${this.teacherStudioUrl}`;
      }
    },
    productUri(): string {
      const productId = this.teacherProduct.id;
      if (this.useCustomDomainUrl && this.hasValidCustomDomain) {
        return encodeURI(`https://${this.domainName}/product/${productId}`);
      }
      if (process.env.VUE_APP_STUDIO_ON_SUBDOMAINS === 'true') {
        return encodeURI(
          getStudentViewURL(
            this.teacherStudioUrl,
            `/product/${productId}`,
            null
          )
        );
      } else {
        const host = window.location.host;
        const protocol = window.location.protocol;
        const uri = encodeURI(
          `${protocol}//${host}/${this.teacherStudioUrl}/product/${productId}`
        );
        return uri;
      }
    },
    hasValidCustomDomain() {
      if (!this.domain) return false;
      if (!this.domain.success) return false;

      return true;
    },
    domainName() {
      return this.domain?.domain;
    },
    purchaseUri(): string {
      const productId = this.teacherProduct.id;
      if (this.useCustomDomainUrl && this.hasValidCustomDomain) {
        return encodeURI(`https://${this.domainName}/buy/product/${productId}`);
      }
      if (process.env.VUE_APP_STUDIO_ON_SUBDOMAINS === 'true') {
        return encodeURI(
          getStudentViewURL(
            this.teacherStudioUrl,
            `/buy/product/${productId}`,
            null
          )
        );
      } else {
        const host = window.location.host;
        const protocol = window.location.protocol;
        const uri = encodeURI(
          `${protocol}//${host}/${this.teacherStudioUrl}/buy/product/${productId}`
        );
        return uri;
      }
    },
    visibilityText(): TranslateResult {
      const teacherProduct = this.teacherProduct as ProductResponse;
      return this.$tc(
        'PRODUCTS.TEXT.VISIBLE_IN_SHOP_VARIANT',
        teacherProduct.visible ? 1 : 0
      );
    },
    enrollmentText(): string {
      return this.$tc(
        'PRODUCTS.TEXT.ENROLMENT_STATE_VARIANT',
        this.teacherProduct.enrollment_enabled
      );
    },
    productId(): number {
      return parseInt(this.$route.params['id']);
    },
    query(): any {
      return {
        id: this.productId,
        product: this.productId,
        q: this.search,
        dateFrom: this.date.startDate,
        dateTo: this.date.endDate,
      };
    },
    eventsQuery(): any {
      return {
        id: this.productId,
        product: this.productId,
        q: this.eventSearch,
        dateFrom: this.eventDate.startDate,
        dateTo: this.eventDate.endDate,
      };
    },
    waitlistQuery(): any {
      return {
        productId: this.productId,
      };
    },
    privateSpaceQuery(): any {
      return {
        id: this.productId,
        product: this.productId,
        q: this.privateSpaceSearch,
        dateFrom: this.privateSpaceDate.startDate,
        dateTo: this.privateSpaceDate.endDate,
      };
    },
    reviewsQuery(): any {
      return {
        id: this.productId,
        product: this.productId,
        q: this.reviewsSearch,
        dateFrom: this.reviewsDate.startDate,
        dateTo: this.reviewsDate.endDate,
      };
    },
    customersCount(): number {
      const customerTableState = this.$store.state['product-customers-table'];
      if (customerTableState) return customerTableState.res.count;
      return 0;
    },
    isPrivateSpaceProduct() {
      return this.teacherProduct?.product_type === 'private_space';
    },
    isRecurring() {
      return this.teacherProduct?.pricing_type === 'recurring';
    },
  },
  methods: {
    getStudentPreviewURL(studioUrl, productId) {
      return getStudentViewURL(
        studioUrl,
        `/product/${productId}`,
        this.teacherMagicCode
      );
    },
    getPurchaseAccessBlockedText(purchase) {
      if (purchase.status) return '';
      if (purchase.is_gift) {
        return this.$t('PRODUCTS.TEXT.GIFT_PURCHASE');
      }
      if (this.isRecurring) {
        if (purchase.is_access_blocked) {
          if (purchase.is_past_available_days)
            return this.$t(
              'PRODUCTS.TEXT.PURCHASE_EXPIRED_PAST_AVAILABILITY_DAYS'
            );
          if (purchase.is_outside_schedule)
            return this.$t('PRODUCTS.TEXT.PRODUCT_SCHEDULE_PREVENTING_ACCESS');
        } else {
          return this.$t('PRODUCTS.TEXT.MEMBERSHIP_HAS_EXPIRED');
        }
      } else {
        if (purchase.is_past_available_days)
          return this.$t(
            'PRODUCTS.TEXT.PURCHASE_EXPIRED_PAST_AVAILABILITY_DAYS'
          );
        if (purchase.is_outside_schedule)
          return this.$t('PRODUCTS.TEXT.PRODUCT_SCHEDULE_PREVENTING_ACCESS');
      }
      return '';
    },
    getProductTypeTranslations,
    formatDate(date: string): string {
      if (!date) return '';
      return formatDate(date, 'date-time');
    },
    navigateToAllProducts(): void {
      this.$router.push({ name: 'My products' });
    },
    editProduct(): void {
      this.$router.push({
        name: 'Edit product',
        params: { id: this.productId },
      });
    },
    async deleteProduct(): Promise<void> {
      try {
        await this.$store.dispatch('product/deleteProduct', this.productId);
        notify(
          this.$t('NOTIFICATIONS.TITLE.SUCCESS').toString(),
          this.$t('PRODUCTS.MODAL.PRODUCT_DELETED_DESCRIPTION').toString()
        );
        this.navigateToAllProducts();
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to delete the product',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async duplicateProduct(): Promise<void> {
      try {
        await this.$store.dispatch('product/duplicateProduct', this.productId);
        notify(
          this.$t('NOTIFICATIONS.TITLE.SUCCESS').toString(),
          this.$t('PRODUCTS.MODAL.PRODUCT_DUPLICATED_DESCRIPTION').toString()
        );
        this.navigateToAllProducts();
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to duplicate the product',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    copy(id: string, value: string): void {
      const element = document.getElementById(id)!;
      const range = document.createRange();
      range.selectNode(element);
      const selection = window.getSelection()!;
      selection.removeAllRanges();
      selection.addRange(range);

      this.$copyText(value).then(() => {
        notify(this.$t('PRODUCTS.TOAST.COPIED') as string, value);
      });

      setTimeout(() => selection.removeAllRanges());
    },
    addCustomerToProductModal(): void {
      this.$modal.show(
        AddCustomerToProductModal,
        {},
        {},
        {
          'before-close': () => {
            this.$refs['product-purchases-table'] &&
              this.$refs['product-purchases-table'].refresh();
            this.$refs['product-customers-table'] &&
              this.$refs['product-customers-table'].refresh();
          },
        }
      );
    },
    async exportCustomersCSV() {
      try {
        await this.$store.dispatch(
          'product/exportTeacherProductCustomers',
          this.query
        );
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('CUSTOMERS.NOTIFICATIONS.CUSTOMER_EXPORT_SUCCESS'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('CUSTOMERS.NOTIFICATIONS.CUSTOMER_EXPORT_ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async exportPurchasesCSV() {
      try {
        await this.$store.dispatch(
          'product/exportTeacherProductPurchases',
          this.query
        );
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('CUSTOMERS.NOTIFICATIONS.PAYMENTS_EXPORT_SUCCESS'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('CUSTOMERS.NOTIFICATIONS.CUSTOMER_EXPORT_ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async exportVideoProgressCSV() {
      try {
        await this.$store.dispatch(
          'product/exportTeacherProductVideoProgress',
          { product: this.productId, name: this.teacherProduct.product_name }
        );
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'CUSTOMERS.NOTIFICATIONS.VIDEO_PROGRESS_EXPORT_SUCCESS'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('CUSTOMERS.NOTIFICATIONS.CUSTOMER_EXPORT_ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    viewCustomer(id): string {
      return `/customers/${id}`;
    },
    async registerCustomersToEvent(data) {
      try {
        this.eventRegistrationInProgress = true;
        const result = await this.$store.dispatch(
          'product/registerProductCustomersToEvent',
          { productId: this.productId, eventId: data.id }
        );
        console.log('registerProductCustomersToEvent: ', result);
        if (result.successful_registrations.length > 0) {
          this.$notify({
            group: 'app',
            type: 'success',
            title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
            text: this.$tc(
              'PRODUCTS.TEXT.REGISTERED_CUSTOMERS_VARIANT',
              result.successful_registrations.length
            ),
          });
          this.$refs['product-events-table'].refresh();
        } else {
          this.$notify({
            group: 'app',
            type: 'info',
            text: this.$t('PRODUCTS.TEXT.NO_CUSTOMERS_REGISTERED'),
          });
        }
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to register customers to the event',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.eventRegistrationInProgress = false;
      }
    },
    async downloadInvoice(student: ProductStudentCustomer): Promise<void> {
      const data = await this.$store.dispatch('sale/downloadInvoice', {
        id: student.id,
      });
      const blob = new Blob([data], { type: 'application/pdf;charset=utf-8;' });
      saveAs(blob, `${this.teacherProduct.product_name}.pdf`);
    },
    async showNotes(student: ProductStudentCustomer) {
      this.$modal.show(CustomerNotesModal, {
        customerId: student.id,
      });
    },
    async loadReportDefinitions() {
      try {
        this.reports = await this.$store.dispatch(
          'report/getMetabaseProductReports'
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load product reports',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async loadCustomDomainInfo() {
      try {
        if (!this.hasValidCustomDomain) {
          await this.$store.dispatch('setting/getDomain');
        }
      } catch (_) {
        // it's ok, domain either not allowed or not found
      }
    },
    selectPaymentPlan(paymentPlan) {
      this.$modal.show(PaymentPlanInvoicesModal, {
        paymentPlan,
        refreshFn: () => {
          this.$refs['product-purchases-table'].refresh();
        },
      });
    },
    async exportWaitlistEmails() {
      try {
        await this.$store.dispatch(
          'product/exportWaitlistEmails',
          this.productId
        );
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'CUSTOMERS.NOTIFICATIONS.WAITLIST_EMAILS_EXPORT_SUCCESS'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t(
            'CUSTOMERS.NOTIFICATIONS.WAITLIST_EMAILS_EXPORT_ERROR'
          ),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async clearWaitlistEmails() {
      await this.$store.dispatch('product/clearWaitlistEmails', this.productId);
      this.$refs.waitlistEmailsTable.refresh();
    },
    openClearWaitlistDialog() {
      this.$modal.show(HMDialog, {
        title: this.$t('PRODUCTS.LINK.CLEAR_WAITLIST'),
        subtitle: '',
        text: this.$t(
          'PRODUCTS.TEXT.ARE_YOU_SURE_THAT_YOU_WANT_TO_CLEAR_WAITLIST'
        ),
        confirm: this.clearWaitlistEmails,
        discard: () => {},
      });
    },
    openFreeClassCardRedemptionsDialog() {
      this.$modal.show(HMDialog, {
        title: this.$t('PRODUCTS.TITLE.AWARD_FREE_REDEMPTIONS'),
        subtitle: '',
        text: this.$t('PRODUCTS.TEXT.AWARD_FREE_REDEMPTIONS_CONFIRMATION', {
          count: this.teacherProduct?.number_of_punches,
        }),
        confirm: this.awardFreeClassCardRedemptions,
        discard: () => {},
      });
    },
    moveCustomersToAnotherProduct() {
      this.$modal.show(
        MoveCustomersToProduct,
        {
          sourceProduct: this.teacherProduct,
        },
        {},
        {
          'before-close': () => {
            this.$refs['product-purchases-table'] &&
              this.$refs['product-purchases-table'].refresh();
            this.$refs['product-customers-table'] &&
              this.$refs['product-customers-table'].refresh();
          },
        }
      );
    },
    async awardFreeClassCardRedemptions() {
      try {
        const payload = {
          productId: this.productId,
        };
        await this.$store.dispatch(
          'product/awardFreeClassCardRedemptions',
          payload
        );
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'NOTIFICATIONS.TEXT.FREE_REDEMPTIONS_SUCCESSFULLY_AWARDED',
            { count: this.teacherProduct?.number_of_punches }
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to award free ClassCard redemptions',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async sendEmailToCustomers() {
      this.$modal.show(HMSendEmailModal, {
        title: this.$t('GENERAL.TITLE.SEND_EMAIL_TO_CUSTOMERS'),
        sendEmail: this._sendEmailToCustomers,
      });
    },
    async _sendEmailToCustomers(subject, body) {
      const payload = {
        productId: this.productId,
        subject,
        body,
      };
      try {
        await this.$store.dispatch('product/emailCustomers', payload);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'NOTIFICATIONS.TEXT.PRODUCT_CUSTOMERS_SUCCESSFULLY_EMAILED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to email product customers',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    viewPrivateSpace({ id }) {
      this.$router.push({ name: 'Product detail', params: { id } });
    },
    getProductDescriptionLength() {
      let html = this.teacherProduct.product_description;
      if (this.teacherProduct.product_description_new) {
        html = renderHtmlFromEditorJS(
          this.teacherProduct.product_description_new
        );
      }
      if (!html) return 0;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      return (doc.body.textContent || '').length;
    },
    async generateProductPage() {
      if (this.getProductDescriptionLength() < 200) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Missing or too short product description',
          text:
            'Please provide a meaningful product description in a couple of sentences.',
          duration: -1, // stay ON
        });
        return;
      }
      this.$modal.show(
        SelectAIToneModal,
        {},
        {},
        {
          'before-close': this._generateProductPage,
        }
      );
    },
    async _generateProductPage($event) {
      console.log('_generateProductPage', $event);
      if (!$event.params) return;

      this.isGeneratingPage = true;
      try {
        await this.$store.dispatch('product/generateProductPage', {
          productId: this.productId,
          tone: $event.params,
        });
        setTimeout(() => {
          this.$notify({
            group: 'app',
            type: 'success',
            title: 'Page generation started',
            text: this.$t('NOTIFICATIONS.TEXT.PRODUCT_PAGE_WILL_BE_GENERATED'),
          });
          this.isGeneratingPage = false;
          this.$router.push({ name: 'pages' });
        }, 1500);
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to generate page',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
        this.isGeneratingPage = false;
      }
    },
    viewReview(reviewId) {
      this.$router.push({
        name: 'Reviews',
        params: { productId: this.productId },
      });
    },
    async showReview(reviewId) {
      try {
        await this.$store.dispatch('product/unhideProductReview', {
          studioUrl: this.studioUrl,
          productId: this.productId,
          reviewId,
        });
        this.$refs['product-reviews-table'].refresh();
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to show review',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async hideReview(reviewId) {
      try {
        await this.$store.dispatch('product/hideProductReview', {
          studioUrl: this.studioUrl,
          productId: this.productId,
          reviewId,
        });
        this.$refs['product-reviews-table'].refresh();
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to hide review',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    openReviewModal(review) {
      this.$modal.show(CustomerProductReviewModal, {
        review,
      });
    },
    openShareProductModal() {
      this.$modal.show(HMShareLinkModal, {
        title: this.$t('PRODUCTS.TITLE.SHARE_PRODUCT'),
        url: this.productUri,
        message: '',
      });
    },
  },
  watch: {
    productId: {
      async handler() {
        try {
          await this.$store.dispatch(
            'product/getTeacherProductDetail',
            this.productId
          );
        } catch (error) {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Failed to load product',
            text: errorToMessage(error.response, `Request failed: ${error}`),
            duration: -1, // stay ON
          });
        }
        this.loadCustomDomainInfo();
        this.loadReportDefinitions();
      },
      immediate: true,
    },
    customersCount: {
      handler(customersCount) {
        if (this.numCustomers < customersCount) {
          this.numCustomers = customersCount;
        }
      },
    },
  },
});
